import { defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import EditableImg from '@smartfire/components/editable-img';
import style from './block.module.scss';
import React from 'react';

const Inspector = React.lazy(() => import('./Inspector'));

function Logo({ link }) {
    const { isEditing } = useEditor();
    useInspectorControl(Inspector);

    const Wrapper = !isEditing && link ? 'a' : 'button';

    return (
        <Wrapper className={style.link} href={!isEditing && link ? link : undefined} target="_blank">
            <EditableImg smartProp={'image'} className={style.image} />
        </Wrapper>
    );
}

export default defineBlock({
    Block: Logo,
    smartProps: {
        image: smartProps.image,
        link: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Logo',
        parent: ['smartfire/logos'],
    },
});
